import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import ripsTitleImage from '../../../../assets/rips/crown-rips-text.png';
import ripsPacksImage from '../../../../assets/rips/rips_packs_widget.png';
import ripsPacksWithTextImage from '../../../../assets/rips/rips_packs_widget_with_text.png';
import Button from '../../../../components/buttons/Button';
import { Loader } from '../../../../components/Loader/Loader';
import { useStores } from '../../../../stores/useStores';
import type { CrownRipsWidgetDataType, WidgetSizeType } from '../../types';
import { GeneralWideWidget } from '../GeneralWidget';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import styles from './CrownRipsWidget.module.scss';

interface CrownRipsWidgetProps {
  sizeType: WidgetSizeType;
  data: CrownRipsWidgetDataType;
}

function CrownRipsWidgetComponent({ data, sizeType }: CrownRipsWidgetProps) {
  const { crownRipsStore } = useStores();
  const { t } = useTranslation();

  // Launch does an async resolve + launch-game round-trip before the game-ui dialog opens; show a
  // full-screen loader for that gap so the tap has immediate feedback (and can't be double-fired).
  const onClick = () => {
    if (crownRipsStore.isLoadingGame) return;
    void crownRipsStore.startCrownRipsGame();
  };

  const isSmall = sizeType === 'small';
  const openLabel = t('common.open');

  return (
    <>
      {/* Narrow: the captioned packs art ("CROWN RIPS" baked in) over an OPEN pill. Wide: the plain
          packs art in the shared wide shell, with the title rendered beside it. */}
      <WidgetWrapper dataTestId={data.dataTestId} sizeType={sizeType} smallWidgetExtended={isSmall} onClick={onClick}>
        {isSmall ? (
          <div className={styles.small}>
            <img alt="" className={styles.smallImg} src={ripsPacksWithTextImage} />
            <Button className={styles.smallBtn}>{openLabel}</Button>
          </div>
        ) : (
          <GeneralWideWidget
            ctaLabel={openLabel}
            title={<img alt="Crown Rips" className={styles.wideTitle} src={ripsTitleImage} />}
            widgetImageUrl={ripsPacksImage}
          />
        )}
      </WidgetWrapper>
      {crownRipsStore.isLoadingGame && <Loader fullScreen />}
    </>
  );
}

export const CrownRipsWidget = observer(CrownRipsWidgetComponent);
